var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 6.00006C17.8124 5.81259 17.5581 5.70728 17.2929 5.70728C17.0278 5.70728 16.7735 5.81259 16.5859 6.00006L11.9999 10.5861L7.41394 6.00006C7.22641 5.81259 6.9721 5.70728 6.70694 5.70728C6.44178 5.70728 6.18747 5.81259 5.99994 6.00006C5.81247 6.18759 5.70715 6.4419 5.70715 6.70706C5.70715 6.97223 5.81247 7.22653 5.99994 7.41406L10.5859 12.0001L5.99994 16.5861C5.81247 16.7736 5.70715 17.0279 5.70715 17.2931C5.70715 17.5582 5.81247 17.8125 5.99994 18.0001C6.18747 18.1875 6.44178 18.2928 6.70694 18.2928C6.9721 18.2928 7.22641 18.1875 7.41394 18.0001L11.9999 13.4141L16.5859 18.0001C16.7735 18.1875 17.0278 18.2928 17.2929 18.2928C17.5581 18.2928 17.8124 18.1875 17.9999 18.0001C18.1874 17.8125 18.2927 17.5582 18.2927 17.2931C18.2927 17.0279 18.1874 16.7736 17.9999 16.5861L13.4139 12.0001L17.9999 7.41406C18.1874 7.22653 18.2927 6.97223 18.2927 6.70706C18.2927 6.4419 18.1874 6.18759 17.9999 6.00006Z",
    fill: "#3E444A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.f808c57990d0755fd08c9a32bd5c89d7.svg";
export { ForwardRef as ReactComponent };